import { getVisibleSceneRect } from "../geometry/viewportTransform";
import { DEFAULT_CANVAS_PALETTE } from "./canvasTheme";

const BASE_GRID_STEP = 20;
const GRID_DOT_RADIUS_PX = 1;
const MIN_SCREEN_SPACING_PX = 14;

/**
 * Grid step in scene units, doubled until dots are at least
 * MIN_SCREEN_SPACING_PX apart on screen — zooming out coarsens the grid
 * instead of flooding the canvas with dots.
 * @param {number} zoom
 * @returns {number}
 */
export const getAdaptiveGridStep = (zoom) => {
  let step = BASE_GRID_STEP;
  while (step * zoom < MIN_SCREEN_SPACING_PX) step *= 2;

  return step;
};

/**
 * Mild dot grid drawn in scene space on the static layer, under the
 * elements, so it pans and zooms with the content. Dots keep a constant
 * on-screen size.
 * @param {{ ctx: CanvasRenderingContext2D, palette?: { grid: string }, size: { width: number, height: number }, viewport: { x: number, y: number, zoom: number } }} params
 * @returns {void}
 */
export const drawCanvasDotGrid = ({
  ctx,
  palette = DEFAULT_CANVAS_PALETTE,
  size,
  viewport,
}) => {
  if (!size.width || !size.height || viewport.zoom <= 0) return;

  const step = getAdaptiveGridStep(viewport.zoom);
  const visibleRect = getVisibleSceneRect({ margin: step, size, viewport });
  const dotRadius = GRID_DOT_RADIUS_PX / viewport.zoom;
  const startX = Math.floor(visibleRect.x / step) * step;
  const startY = Math.floor(visibleRect.y / step) * step;
  const endX = visibleRect.x + visibleRect.width;
  const endY = visibleRect.y + visibleRect.height;

  ctx.beginPath();
  for (let dotX = startX; dotX <= endX; dotX += step) {
    for (let dotY = startY; dotY <= endY; dotY += step) {
      ctx.rect(dotX - dotRadius, dotY - dotRadius, dotRadius * 2, dotRadius * 2);
    }
  }
  ctx.fillStyle = palette.grid;
  ctx.fill();
};
